export const environment = {
  production: true,
  serverUrl: 'https://www.wholesale-flights.com/__api',
  cdnPath: '.',
  recaptchaSiteKey: '6Lfk_T4pAAAAAKnoJcqrfbgXUcquFxnrwnfEdZlW',
  // cdnPath: 'https://p7k3r6k3.stackpathcdn.com'
  // cdnPath: 'https://cdn.wholesale-flights.com'
};

// TODO: Move recaptchaSiteKey to AppModule via RECAPTCHA_SETTINGS after updating ng-recaptcha to v9+
